import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { AssetGroupTreeAssigment } from '../entities/assets/assetgrouptreeassigment.entity';
import { AssetGroupTreeMetaData } from '../entities/assets/assetgrouptreemetadata.entity';
import { AssetGroupTree } from '../entities/assets/assetgrouptree.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class AssetGroupTreeService extends ODataEntityService<AssetGroupTree> {
  constructor(protected client: ODataClient) {
    super(client, 'AssetGroupTree', 'entities.assets.AssetGroupTree');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public assetGroupTreeAssigments(entity: EntityKey<AssetGroupTree>): ODataNavigationPropertyResource<AssetGroupTreeAssigment> {
    return this.entity(entity).navigationProperty<AssetGroupTreeAssigment>('assetGroupTreeAssigments');
  }
  public metaDatas(entity: EntityKey<AssetGroupTree>): ODataNavigationPropertyResource<AssetGroupTreeMetaData> {
    return this.entity(entity).navigationProperty<AssetGroupTreeMetaData>('metaDatas');
  }
  public status(entity: EntityKey<AssetGroupTree>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<AssetGroupTree>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
